import { IntegrationStatus } from 'graphqlAPI'

export const IntegrationStatusEnumerate = {
  [IntegrationStatus.Pending]: 0,
  [IntegrationStatus.InvitedToProgram]: 1,
  [IntegrationStatus.EnrolledInProgram]: 2,
  [IntegrationStatus.InvitedToCourse]: 3,
  [IntegrationStatus.EnrolledInCourse]: 4,
  [IntegrationStatus.NoAccount]: 5,
  [IntegrationStatus.UncontrolledError]: 6,
} as Record<IntegrationStatus, number>
